// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__PdpSn","icon":"SearchBar_icon__cSo5G","input":"SearchBar_input__1gJEc"};